export default "__VITE_ASSET__BDOKYuHO__"